import { Component, OnInit } from '@angular/core';
import { GeneralExerciseComponent } from '../../General/g-exercise.component';
import { ActivatedRoute } from '@angular/router';
import { TopicService } from '../topic.service';
import { MessageService } from '../../shared/message.service';

@Component({
  selector: 'app-discover',
  templateUrl: './discover.component.html',
  styleUrls: ['./discover.component.css']
})
export class DiscoverComponent extends GeneralExerciseComponent {

  hints: any[];
  requiredImage: string[][];

  compressedText: string;
  tipCount: number = 1;


  constructor(activatedRoute: ActivatedRoute, topicService: TopicService, messageService: MessageService) {
    super(activatedRoute, topicService, messageService);
  }

  setTypeSpecificsFromConfiguration(){
    this.hints = this.configuration.typespecifics.hints;
    this.requiredImage = this.configuration.typespecifics.required;
    console.log(this.requiredImage);
    this.tipCount = 1;
    this.compressedText = "";
  }

  setTypeSpecificsFromState(){
    if (this.state.typespecific) {
      if (this.state.typespecific.compressedText) {
        this.compressedText = this.state.typespecific.compressedText;
      }
      if (this.state.typespecific.tipCount) {
        this.tipCount = this.state.typespecific.tipCount;
      }
    }
  }

  computeState(){
    this.state.typespecific.compressedText = this.compressedText;
    this.state.typespecific.tipCount = this.tipCount;
  }

  checkSolution(){
    //compute solution
    let imageString = this.requiredImage.map(v => v.join("")).join("");
    let lastSign = "";
    let count = 0;
    let solution = "";
    for (let c of imageString) {
      if (c == lastSign) {
        count++;
      } else {
        if (count > 0) {
          solution = solution.concat(count.toString(), lastSign);
        }
        lastSign = c;
        count = 1;
      }
    }
    solution = solution.concat(count.toString(), lastSign);

    console.log(solution);

    let counts = this.compressedText.split(/([0-9]+)/);
    let studentImage = "";

    for (let i = 1; i < counts.length; i += 2) {
      studentImage = studentImage.concat(counts[i + 1].repeat(+counts[i]));
    }

    if (imageString != studentImage) {
      this.messageService.addAlertWithTimeout(this.get("wrongImage"), "danger", 10000);
      return;
    }

    if (this.compressedText != solution) {
      this.messageService.addAlertWithTimeout(this.get("wrongImageCompression"), "danger", 10000);
      return;
    }

    this.messageService.addAlertWithTimeout(this.get("correct"), "success", 10000);
    this.state.solved = true;
    this.solved = true;
    this.saveState();

  }

  evaluate(): number[] { 
    let imageString = this.requiredImage.map(v => v.join("")).join("");

    let studentImage = "";
    let counts = this.compressedText.split(/([0-9]+)/);

    for (let i = 1; i < counts.length; i += 2) {
      studentImage = studentImage.concat(counts[i + 1].repeat(+counts[i]));
    }
    let errors = imageString.split("").map((v, i) => [v, i]).filter(v => v[0] != studentImage.charAt(+v[1])).map(v => v[1]).map(v => [Math.floor(+v / 10), +v % 10]);
    console.log(errors);
    let solution = "";
    let lastSign = "";
    let count = 0;
    for (let c of imageString) {
      if (c == lastSign) {
        count++;
      } else {
        if (count > 0) {
          solution = solution.concat(count.toString(), lastSign);
        }
        lastSign = c;
        count = 1;
      }
    }
    solution = solution.concat(count.toString(), lastSign);

    if (this.compressedText != solution) {
      return [(100 - errors.length) / 100 * 3, 5];
    }
    return [(100 - errors.length) / 100 * 5, 5];
  }


  /** returns the expanded name of the abreviated color */
  color(c: string) {
    switch (c) {
      case "k": return "black";
      case "c": return "cyan";
      case "m": return "magenta";
      case "y": return "yellow";
      case "r": return "red";
      case "g": return "green";
      case "b": return "blue";
      default: return "white";
    }
  }

  /** shows an additional tip */
  incrementTip(){
    if(this.tipCount < this.hints.length){
      this.tipCount++;
    }
  }
  

}
